module.exports = __webpack_public_path__ + "img/icon_ing1.565cc5b.png";